package horcrux.common.api

object APILimits {
    const val MAX_CHUNK_OVERLAP: Int = 100
    const val MAX_COLLECTION_NAME_LENGTH: Int = 100
    const val MAX_DOCUMENT_NAME_LENGTH: Int = 100
    const val MAX_MAX_CHUNK_SIZE: Int = 1000
    const val MAX_NUM_CHUNKS: Int = 100
    const val MAX_POST_DOCUMENTS_BATCH_SIZE: Int = 10
    const val MAX_USER_FEEDBACK_SIZE: Int = 1000
    const val MIN_CHUNK_OVERLAP: Int = 0
    const val MIN_COLLECTION_NAME_LENGTH: Int = 1
    const val MIN_DOCUMENT_NAME_LENGTH: Int = 1
    const val MIN_MAX_CHUNK_SIZE: Int = 10
    const val MIN_NUM_CHUNKS: Int = 1
    const val MIN_USER_FEEDBACK_SIZE: Int = 1
}
